var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-chart-axis"},[_vm._l((_vm.data),function(item,i){return _c('span',{key:i,class:[{ primary: _vm.showTitle(i, item) }],attrs:{"title":_vm.showTitle(i, item)}})}),_c('span')],2)}
var staticRenderFns = []

export { render, staticRenderFns }